module.exports = new __parcel__URL__("turtle.acbe0058.svg").toString();